module.exports = {"pt-BR":{"admin":{"scoreReports":{"scoreCard":{"scoreSteps":{"details":{"format":{"stepTable":{"values":{"true":"Sim","false":"Não"}}}}}}}}}}